<div class="box">
  <div class="header">
    <div class="section-title">Reward chances</div>
    <div fxFlex></div>
    <button mat-button color="primary" type="button" (click)="addRewardChance()" matTooltip="Add reward chance"><mat-icon>add</mat-icon> Add chance</button>
  </div>
  <div class="content" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="5px">

    <div fxLayout="row wrap" fxLayoutAlign="start" fxLayoutGap="5px">
      @for (grpChance of form.controls.rewardChances['controls']; track grpChance; let i = $index) {
        <div
          fxLayout="column" fxLayoutAlign="start"
          class="reward-chance-item"
          [class.error]="grpChance.errors?.rewardInvalid">
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
            <div fxFlex="100px" class="section-info">Chance {{ i + 1 }}</div>
            <button (click)="onRemoveChance(i)" mat-button color="primary" type="button" matTooltip="Remove chance"><mat-icon>delete</mat-icon></button>
          </div>
          <mat-form-field>
            <mat-label>Chance (0-1)</mat-label>
            <input matInput type="number" placeholder="" min="0" max="1" step=".01" [formControl]="grpChance['controls'].chance">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Reward coins</mat-label>
            <mat-select [compareWith]="compareRewardFn" placeholder="" [formControl]="grpChance['controls'].coinReward">
              <mat-option [value]="null"></mat-option>
              @for (coinReward of coinRewardOptions; track coinReward) {
                <mat-option [value]="coinReward">{{ coinReward.coins }} coins reward</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div fxLayout="row" fxLayoutAlign="space-between">
            <mat-form-field fxFlex>
              <mat-label>Reward product</mat-label>
              <mat-select [compareWith]="compareProductRewardFn" placeholder="" [formControl]="grpChance['controls'].productReward">
                <mat-option [value]="null"></mat-option>
                @for (product of rewardProductsOptions; track product) {
                  <mat-option [value]="product" [matTooltip]="product.productSlug">{{ product.rewardTitle }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- <button fxFlex *ngIf="!rewardProductsOptions[i]" (click)="onAddRewardProduct(i)" mat-icon-button color="primary" type="button" matTooltip="Add reward product"><mat-icon>add</mat-icon></button>
            <button fxFlex *ngIf="rewardProductsOptions[i]" (click)="onRemoveRewardProduct(i)" mat-icon-button color="primary" type="button" matTooltip="Delete reward product"><mat-icon>delete</mat-icon></button> -->
          </div>
        </div>
      }
    </div>

    @if (form.dirty && form?.errors?.rewardRequired) {
      <mat-error >At least one reward is required</mat-error>
    }
  </div>
</div>